import { FC, useEffect, useState } from "react";
import PageHeader from "components/common/ui/PageHeader";
import { Container } from "@mui/material";
import { useAppDispatch, useAppSelector } from "hooks/useReduxStore";
import { useParams } from "react-router-dom";
import MenuEditForms from "components/menu/ui/MenuEditForms";
import jspPlatformApi from "client/portals";
import { menuDetailActions } from "store/slices/menu/menuDetailSlice";
import { actions as foodItemOptionsActions } from "store/slices/food/foodItemOptionsSlice";
import foodItemOptionsSelector from "store/selectors/food/foodItemOptionsSelector";
import { rawMenuEditReadQuery } from "utils/menu/menu/menuQueryUtils";

interface MenuEditPageProps {}

const MenuEditPage: FC<MenuEditPageProps> = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const foodItemOptions = useAppSelector(
    foodItemOptionsSelector.foodDishOptions,
  );
  const { menuId } = useParams();

  /**
   * Use effect to load the menu to edit
   */
  useEffect(() => {
    const navToEditMenuId: number | undefined = menuId
      ? Number(menuId)
      : undefined;
    if (navToEditMenuId) {
      setIsLoading(true);
      jspPlatformApi()
        // Load the raw stored menu for editing: no server-side fill-ins, so
        // the form only shows (and later saves) what the user actually set.
        .menu.getMenuMealByMenuId({
          path: { menu_id: navToEditMenuId },
          query: rawMenuEditReadQuery,
        })
        .then((res) => {
          dispatch(menuDetailActions.setMenuDetail(res.data ?? null));
        })
        .catch(() => {
          dispatch(menuDetailActions.setMenuDetail(null));
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [dispatch, menuId]);

  /**
   * Clear menu template details on unmount
   */
  useEffect(() => {
    return () => {
      dispatch(menuDetailActions.reset());
    };
  }, [dispatch]);

  /**
   * Make sure FoodItemOptions is the latest
   */
  useEffect(() => {
    dispatch(foodItemOptionsActions.fetchAllFoodItemOptions());
  }, [dispatch]);

  return (
    <Container>
      <PageHeader>Menu Details</PageHeader>
      {isLoading ? (
        <div>Loading...</div>
      ) : (
        <MenuEditForms foodItemOptions={foodItemOptions} />
      )}
    </Container>
  );
};

export default MenuEditPage;
